<article class="bar-card">
  <header class="bar-card__header">
    <div class="bar-card__headings">
      <h3 class="bar-card__title">{{ title }}</h3>
      @if (totalHint) {
        <p class="bar-card__subtitle">{{ totalHint }}</p>
      }
    </div>
    <img src="assets/icons/pulse.svg" alt="" aria-hidden="true" class="bar-card__icon"/>
  </header>

  <div class="bar-card__body">
    <div class="bar-card__chart" (mousemove)="onChartMouseMove($event)">
        <ngx-charts-bar-horizontal-stacked
          [results]="normalized()"
          [scheme]="colorScheme"
          [legend]="false"
          [showGridLines]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="false"
          [xAxisTickFormatting]="xTickFormat"
          [xAxisTicks]="xTicks"
          [xScaleMax]="xMax"
          [xAxisLabel]="xAxisLabel"
          [xAxis]="true"
          [barPadding]="4"
          [yAxis]="true"
          [tooltipDisabled]="true"
          (activate)="onActivate($event)"
          (deactivate)="onDeactivate()"
          (mousemove)="onChartMouseMove($event)">
        </ngx-charts-bar-horizontal-stacked>
      @if (tooltipVisible) {
        <div class="bar-tooltip"
             [ngStyle]="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
          {{ tooltipText }}
        </div>
      }
    </div>

    @if (legendData.length) {
      <aside class="bar-card__legend">
        <div class="chart-legend">
          @for (item of legendData; track item) {
            <div class="legend-item">
              <div class="legend-item__color" [style.background-color]="item.value"></div>
              <div class="legend-item__label">{{ item.name }}</div>
            </div>
          }
        </div>
      </aside>
    }
  </div>
</article>
